import {
  required,
  requiredIf,
  sameAs,
  email,
  maxLength,
  helpers,
} from "vuelidate/lib/validators";
import { FinnishSSN } from "finnish-ssn";
import unique from "./unique";

const noNumbersAllowed = helpers.regex("noNumbersAllowed", /^([^0-9]*)$/);

export const extendApplicantCreator =
  (extend = {}) =>
  (presets = {}) => ({
    id: unique(),
    FirstName: "",
    LastName: "",
    Ssn: "",
    Address: "",
    PostalCode: "",
    City: "",
    usePrimaryApplicantAddress: false,
    Phone: "",
    PhoneCountryCode: "+358",
    ContactLanguage: "fi",
    Email: "",
    emailAgain: "",
    MarketingAllowed: false,
    ...extend,
    ...presets,
  });

const filled = (value) => !["", null, false].includes(value);

// Custom validators
// https://vuelidate.netlify.com/#sub-locator-based-validator
const ssn = (value) =>
  !helpers.req(value) ||
  (!value.includes("+") && FinnishSSN.validate(value.toUpperCase()));
const phone = (value) => /^[0-9]*$/.test(value);
const requiredOr = (prop) => (value, vm) =>
  filled(helpers.ref(prop, this, vm)) || filled(value);
const numericOr = (prop) => (value, vm) =>
  filled(helpers.ref(prop, this, vm)) || /^\d*$/.test(value);
const noDigitsOr = (prop) => (value, vm) =>
  filled(helpers.ref(prop, this, vm)) || !/\d/.test(value);
const maxLengthOr = (max, prop) =>
  helpers.withParams({ max }, (value, vm) => {
    return filled(helpers.ref(prop, this, vm)) || helpers.len(value) <= max;
  });
const minLengthOr = (min, prop) =>
  helpers.withParams({ min }, (value, vm) => {
    return filled(helpers.ref(prop, this, vm)) || helpers.len(value) >= min;
  });
function applicationUniqueSsn(valueRaw) {
  const normalize = (string) => string.toLowerCase();
  const value = normalize(valueRaw);
  return this.allSsns.filter((a) => normalize(a) === value).length === 1;
}

export const validations = {
  applicant: {
    $trackBy: "id",
    FirstName: {
      required,
      maxLength: maxLength(50),
      noNumbersAllowed,
    },
    LastName: {
      required,
      maxLength: maxLength(50),
      noNumbersAllowed,
    },
    Ssn: {
      required,
      ssn,
      applicationUniqueSsn,
    },
    Address: {
      required: requiredOr("usePrimaryApplicantAddress"),
      maxLength: maxLengthOr(250, "usePrimaryApplicantAddress"),
    },
    PostalCode: {
      required: requiredOr("usePrimaryApplicantAddress"),
      numeric: numericOr("usePrimaryApplicantAddress"),
      maxLength: maxLengthOr(5, "usePrimaryApplicantAddress"),
      minLength: minLengthOr(5, "usePrimaryApplicantAddress"),
    },
    City: {
      required: requiredOr("usePrimaryApplicantAddress"),
      noDigits: noDigitsOr("usePrimaryApplicantAddress"),
      maxLength: maxLengthOr(80, "usePrimaryApplicantAddress"),
    },
    usePrimaryApplicantAddress: {},
    Phone: {
      required,
      phone,
      maxLength: maxLength(50),
    },
    PhoneCountryCode: {
      required,
      requiredIfPhone: requiredIf(({ Phone }) => {
        return filled(Phone);
      }),
    },
    ContactLanguage: {
      required,
    },
    Email: {
      required,
      email,
      maxLength: maxLength(100),
    },
    emailAgain: {
      sameAs: sameAs("Email"),
    },
    ContactLanguage: {
      required,
    },
    MarketingAllowed: {},
  },
  form: {
    OtherResidents: {
      $each: {
        $trackBy: "id",
        FirstName: {
          required,
          maxLength: maxLength(50),
          noNumbersAllowed,
        },
        LastName: {
          required,
          maxLength: maxLength(50),
          noNumbersAllowed,
        },
        Ssn: {
          required,
          ssn,
          applicationUniqueSsn,
        },
      },
    },
  },
};
